import { createSlice } from "@reduxjs/toolkit";
import { loginwithfacebook, loginwithgoogle } from "../../thunks/authThunk";
import { login, logoute } from "../../utils/util";

const initialState = {
  user: null,
  loading: false,
  isAuthenticated: false,
  error: null,
};

const authSlice = createSlice({
  name: "auth",
  initialState,
  reducers: {
    logout: (state) => {
      state.user = null;
      state.isAuthenticated = false;
      logoute();
    },
    setInitialAuthState: (state, action) => {
      state.user = action.payload;
      state.isAuthenticated = !!action.payload;
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(loginwithgoogle.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(loginwithgoogle.fulfilled, (state, action) => {
        state.user = action.payload;
        state.loading = false;
        state.isAuthenticated = true;
        login(action.payload);
      })
      .addCase(loginwithgoogle.rejected, (state, action) => {
        state.user = null;
        state.loading = false;
        state.isAuthenticated = false;
        state.error = action.error.message;
      })
      .addCase(loginwithfacebook.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(loginwithfacebook.fulfilled, (state, action) => {
        state.user = action.payload;
        state.loading = false;
        state.isAuthenticated = true;
        login(action.payload);
      })
      .addCase(loginwithfacebook.rejected, (state, action) => {
        state.user = null;
        state.loading = false;
        state.isAuthenticated = false;
        state.error = action.error.message;
      });
  },
});

export const { logout, setInitialAuthState } = authSlice.actions;
export default authSlice.reducer;

// Selectors
export const selectUser = (state) => state.auth.user;
export const selectLoading = (state) => state.auth.loading;
export const selectIsAuthenticated = (state) => state.auth.isAuthenticated;
export const selectAuthError = (state) => state.auth.error;
